import { Dispatch } from 'redux';
import { NotificationActions } from '../store/NotificationSlice';
import { OutageActions } from '../store/OutageSlice';
import SetAuthHeader, { ManageResponseErrors } from './actionUtils';
import { AccessToken } from '@okta/okta-auth-js';
import { OutageSearchParams } from '../components/Outages/Outage';
import { NotificationStatus } from '../components/Notification/Notification';

export const getOutages = (searchParams: OutageSearchParams, apiUrl: string, accessToken: AccessToken,
            curPage: number, rowsPerPage: number, displayNotification: boolean) => {
    return async (dispatch: Dispatch) => {
        const fetchData = async () => {
            if (displayNotification) {
                dispatch(NotificationActions.showNotification({
                    status: 'Searching',
                    title: 'Search',
                    message: 'Fetching Outage Data'
                }));
            }
            const response = await fetch(`${apiUrl}/api/Outage/getOutages?siteCode=${searchParams.SiteId}&start=${searchParams.StartDate}&end=${searchParams.EndDate}&curPage=${curPage}&rowsPerPage=${rowsPerPage}`
                , SetAuthHeader(accessToken));

            ManageResponseErrors(response);
            if (response.status === 204) {
                return [];
            }

            const data = await response.json();
            return data;
        };

        try {
            const outages = await fetchData();
            dispatch(OutageActions.setOutageResults({ data: outages }));
            if (displayNotification) {
                dispatch(NotificationActions.showNotification({
                    status: NotificationStatus.Success,
                    title: 'Success',
                    message: 'Completed fetching Outage Data'
                }));
            }
        }
        catch (error) {
            dispatch(
                NotificationActions.showNotification({
                    status: 'Error',
                    title: 'Error!',
                    message: 'Fetching Outage Info failed!'
                })
            );
        }
    };
};

export const clearOutages = () => {
    return async (dispatch: Dispatch) => {
        dispatch(OutageActions.clearResultData({ data: [] }));
    }
}